export default (spaceString: string): string => {
	if (spaceString) {
		return spaceString.replace(/ /gm, '\xa0')
	}
	return spaceString;
};